import classnames from 'classnames';
import React, { FC, ReactElement } from 'react';
import { Link } from 'react-router-dom';

import './Breadcrumbs.scss';

type Segment = {
  name: string | ReactElement;
  url?: string;
};

type SegmentItemProps = Segment & {
  last?: boolean;
  separator?: string;
};

type Props = {
  className?: string;
  path: Segment[];
  separator?: string;
};

const SegmentItem: FC<SegmentItemProps> = (props) => {
  return (
    <li className="breadcrumbs__item" data-separator={props.separator}>
      {props.url && (
        <Link className="breadcrumbs__link" to={props.url} aria-current={props.last ? 'page' : undefined}>
          {props.name}
        </Link>
      )}
      {!props.url && props.name}
    </li>
  );
};

const Breadcrumbs: FC<Props> = (props) => {
  const separator = props.separator || '/';

  const hostCN = classnames('breadcrumbs', props.className);
  return (
    <nav className={hostCN} aria-label="Breadcrumb">
      <ol className="breadcrumbs__path">
        {props.path.map((segment, index) => (
          <SegmentItem
            key={`segment-${index}`}
            {...segment}
            last={props.path.length === index + 1}
            separator={separator}
          />
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
